














































































































































































// @ts-nocheck
import { Dictionary } from "lodash";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import {
  ApiMessage,
  ControllersApi,
  PostControllerRequest,
  PostUnitRequest,
  PutControllerRequest,
  PutUnitRequest,
  UnitsApi,
} from "../../../apis";
import { ACT, TYPE } from "./index";
@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
  },
})
export default class UnitControllerDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({}) mode: string;
  @Prop({ default: {} }) selectedPermisstion: any;
  @Prop({}) type: string;
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;
  titleAdd = "";
  titleEdit = "";
  buttonAdd = "";
  buttonEdit = "";
  content = "";
  contentName = "";
  unitTypes = ["" ,"CA", "MA", "STATION", "CFP"];
  locationId = this.$route.params.id;
  zoneItems: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  readonly DEFAULT_TOLERANCE_OUTREACH_TEMP = 0;
  readonly DEFAULT_TOLERANCE_OUTREACH_O2 = 0.3;

  private normalizeToleranceValue(value: any, defaultValue: number): number {
    // TS 3.3 compatible (no nullish coalescing). Keep 0 as a valid value.
    if (value === null || value === undefined || value === "") return defaultValue;
    const num = Number(value);
    return Number.isFinite(num) ? num : defaultValue;
  }

  get show() {
    if (this.mode === ACT.NEW) {
      this.selectedPermisstion.type = "";
      this.selectedPermisstion.toleranceOutreachTemp =
        this.DEFAULT_TOLERANCE_OUTREACH_TEMP;
      this.selectedPermisstion.toleranceOutreachO2 =
        this.DEFAULT_TOLERANCE_OUTREACH_O2;
    } else {
      // Ensure defaults for old data that does not have these fields
      this.selectedPermisstion.toleranceOutreachTemp =
        this.normalizeToleranceValue(
          this.selectedPermisstion.toleranceOutreachTemp,
          this.DEFAULT_TOLERANCE_OUTREACH_TEMP
        );
      this.selectedPermisstion.toleranceOutreachO2 =
        this.normalizeToleranceValue(
          this.selectedPermisstion.toleranceOutreachO2,
          this.DEFAULT_TOLERANCE_OUTREACH_O2
        );
    }
    return this.value;
  }
  get editMode() {
    return this.mode === ACT.EDIT;
  }
  get newMode() {
    return this.mode === ACT.NEW;
  }
  get controllerType() {
    return this.type === TYPE.CONTROLLER;
  }
  get unitType() {
    return this.type === TYPE.UNIT;
  }
  set show(value) {
    if(this.observer) this.observer.reset();
    this.$emit("input", value);
  }
  get getTitle() {
    switch (this.type) {
      case TYPE.CONTROLLER: {
        return (this.titleAdd = this.$t("text.addController").toString());
        break;
      }
      case TYPE.UNIT: {
        return (this.titleAdd = this.$t("text.addUnit").toString());
        break;
      }
      default: {
        break;
      }
    }
  }
  get getTitleEditMode() {
    switch (this.type) {
      case TYPE.CONTROLLER: {
        return (this.titleAdd = this.$t("text.editController").toString());
        break;
      }
      case TYPE.UNIT: {
        return (this.titleAdd = this.$t("text.editUnit").toString());
        break;
      }
      default: {
        break;
      }
    }
  }
  get getButtonAdd() {
    switch (this.type) {
      case TYPE.CONTROLLER: {
        return (this.buttonAdd = this.$t("button.addController").toString());
        break;
      }
      case TYPE.UNIT: {
        return (this.buttonAdd = this.$t("button.addUnit").toString());
        break;
      }
      default: {
        break;
      }
    }
  }
  get getButtonEdit() {
    switch (this.type) {
      case TYPE.CONTROLLER: {
        return (this.buttonEdit = this.$t("button.save").toString());
        break;
      }
      case TYPE.UNIT: {
        return (this.buttonEdit = this.$t("button.save").toString());
        break;
      }
      default: {
        break;
      }
    }
  }

  onSave() {
    this.observer.validate().then((success) => {
      if (!success) {
        this.$util.goToErrorField(this.observer);
        return;
      }
      if (this.controllerType) {
        this.addControllerHandle();
      } else {
        this.addUnitHandle();
      }
    });
  }

  onEdit() {
    this.observer.validate().then((success) => {
      if (!success) {
        this.$util.goToErrorField(this.observer);
        return;
      }
      if (this.controllerType) {
        this.editControllerHandle();
      } else {
        this.editUnitHandle();
      }
    });
  }

  async editUnitHandle() {
    this.$util.showLoading();
    try {
      const body = {
        name: this.selectedPermisstion.name,
        type: this.selectedPermisstion.type,
        description: this.selectedPermisstion.description,
        zone: this.selectedPermisstion.zone,
        noneTreatment: this.selectedPermisstion.noneTreatment,
        freeText: this.selectedPermisstion.freeText,
        toleranceOutreachTemp:
          this.normalizeToleranceValue(
            this.selectedPermisstion.toleranceOutreachTemp,
            this.DEFAULT_TOLERANCE_OUTREACH_TEMP
          ),
        toleranceOutreachO2:
          this.normalizeToleranceValue(
            this.selectedPermisstion.toleranceOutreachO2,
            this.DEFAULT_TOLERANCE_OUTREACH_O2
          ),
        location: this.locationId,
      } as PutUnitRequest;
      await new UnitsApi().editUnit({
        id: this.selectedPermisstion.id,
        putUnitRequest: body,
      });
      this.onClose();
      (this as any).$emit("onSave", "saved");
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async editControllerHandle() {
    this.$util.showLoading();
    try {
      const body = {
        ipAddress: this.selectedPermisstion.ipAddress,
        name: this.selectedPermisstion.name,
        description: this.selectedPermisstion.description,
        location: this.locationId,
      } as PutControllerRequest;
      await new ControllersApi().editController({
        id: this.selectedPermisstion.id,
        putControllerRequest: body,
      });
      this.onClose();
      (this as any).$emit("onSave", "saved");
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
  async addUnitHandle() {
    this.$util.showLoading();
    try {
      const body = {
        name: this.selectedPermisstion.name,
        type: this.selectedPermisstion.type,
        description: this.selectedPermisstion.description,
        zone: this.selectedPermisstion.zone,
        noneTreatment: this.selectedPermisstion.noneTreatment,
        freeText: this.selectedPermisstion.freeText,
        toleranceOutreachTemp:
          this.normalizeToleranceValue(
            this.selectedPermisstion.toleranceOutreachTemp,
            this.DEFAULT_TOLERANCE_OUTREACH_TEMP
          ),
        toleranceOutreachO2:
          this.normalizeToleranceValue(
            this.selectedPermisstion.toleranceOutreachO2,
            this.DEFAULT_TOLERANCE_OUTREACH_O2
          ),
        location: this.locationId,
      } as PostUnitRequest;
      await new UnitsApi().addUnit({
        postUnitRequest: body,
      });
      this.onClose();
      (this as any).$emit("onSave", "saved");
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async addControllerHandle() {
    this.$util.showLoading();
    try {
      const body = {
        ipAddress: this.selectedPermisstion.ipAddress,
        name: this.selectedPermisstion.name,
        description: this.selectedPermisstion.description,
        location: this.locationId,
      } as PostControllerRequest;
      await new ControllersApi().addNewController({
        postControllerRequest: body,
      });
      this.onClose();
      (this as any).$emit("onSave", "saved");
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  onClose() {
    this.selectedPermisstion.ipAddress = "";
    this.selectedPermisstion.name = "";
    this.selectedPermisstion.description = "";
    this.selectedPermisstion.type = "";
    this.selectedPermisstion.freeText = "";
    this.selectedPermisstion.toleranceOutreachTemp =
      this.DEFAULT_TOLERANCE_OUTREACH_TEMP;
    this.selectedPermisstion.toleranceOutreachO2 =
      this.DEFAULT_TOLERANCE_OUTREACH_O2;
    this.show = false;
  }

  get apiMessages(): Dictionary<ApiMessage[]> {
    return this.$store.getters.apiMessages;
  }

  @Watch("apiMessages", { deep: true })
  apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
    this.$util.showApiError(messages, this.observer);
  }
}
